import { render, staticRenderFns } from "./NotificationPreferenceSetting.vue?vue&type=template&id=1f674dbc&scoped=true&"
import script from "./NotificationPreferenceSetting.vue?vue&type=script&lang=ts&"
export * from "./NotificationPreferenceSetting.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPreferenceSetting.vue?vue&type=style&index=0&id=1f674dbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f674dbc",
  null
  
)

export default component.exports